import { defineSetting } from '../settingsRegistry';
import { tierIndex } from '../graphics';

declare module '../settingsRegistry' {
  interface Settings {
    /** Region streaming radius in chunks (1 = 3×3, 2 = 5×5, 3 = 7×7); 0 = by quality tier. No menu row. */
    regionStream: number;
  }
}

defineSetting({ key: 'regionStream', default: 0, order: 1010 });

/** Chunk radius streamed around the player by tier: 0 -> 3×3, 1 -> 5×5, 2+ -> 7×7. */
export function streamRadiusFor(tier: number): number {
  return tier <= 0 ? 1 : tier === 1 ? 2 : 3;
}

/** The radius in use: the setting if set (1..3), else by the current tier. */
export function regionStreamRadius(override: number): number {
  return override >= 1 ? Math.min(3, Math.round(override)) : streamRadiusFor(tierIndex());
}
